import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { TenancyRequest } from "@eres/ejari-api/Entity/tenant";
import { EjariApi } from "@eres/ejari-api";
import { EjariCoreConfig, TenantRequestUserType } from "@eres/ejari-core/constants";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import TenantRequestsListView from "../../../component/TenantRequests/TenantRequestsListView";
import TenantRequestsGridView from "../../../component/TenantRequests/TenantRequestsGridView";
import { showTenantReqDetails } from "./MyTenantRequests";

interface State {
	isLoading: boolean;
	requests: TenancyRequest[];
}

class RequestsFromTenant extends Component<RoutedViewProps, State> {
	constructor( props: RoutedViewProps ) {
		super( props );
		this.state = {
			isLoading: true,
			requests: [],
		};
	}

	componentDidMount(): void {
		this.loadTenancyRequests();
	}

	render() {
		const { isLoading, requests } = this.state;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ requests.length > 0 }
			title={ Strings.requests_from_tenant }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }/>;
	}

	private renderListView = () => {
		const { requests } = this.state;
		return <TenantRequestsListView
			items={ requests }
			onDetails={ ( request: TenancyRequest ) => {
				showTenantReqDetails( request, TenantRequestUserType.OWNER );
			} }/>;
	};

	private renderGridView = () => {
		const { requests } = this.state;
		return <TenantRequestsGridView
			items={ requests }
			onDetails={ ( request: TenancyRequest ) => {
				showTenantReqDetails( request, TenantRequestUserType.OWNER );
			} }/>;
	};

	private loadTenancyRequests() {
		EjariApi.getTenancyRequests( EjariCoreConfig.getParticipantID()!, 0, TenantRequestUserType.OWNER )
		.then( ( requests: TenancyRequest[] ) => {
			this.handleResponse( requests );
		} ).catch( reason => {
			this.handleResponse( [] );
		} );
	}

	private handleResponse( requests: TenancyRequest[] ) {
		this.setState( {
			requests: requests,
			isLoading: false,
		} );
	}
}

export default RequestsFromTenant;
